import { configureStore } from '@reduxjs/toolkit';
import kpiReducer from '@features/kpi/kpiSlice';
import pmReducer from '@features/performanceManagement/pmSlice';
import workspaceReducer from '@features/performanceManagement/workspaceSlice';
import mapReducer from '@features/webGIS/mapSlice';
import counterReducer from '@features/counter/counterSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    kpis: kpiReducer,
    pms: pmReducer,
    map: mapReducer,
    workspace: workspaceReducer,
  },
});
